import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'orderBy',
    standalone: true
})
export class OrderByPipe implements PipeTransform {

    transform(array: any[], field: string, ascending: boolean = true): any[] {
        if (!Array.isArray(array)) {
            return [];
        }
        const sortedArray = array.sort((a, b) => {
            if (a[ field ] < b[ field ]) {
                return ascending ? -1 : 1;
            } else if (a[ field ] > b[ field ]) {
                return ascending ? 1 : -1;
            } else {
                return 0;
            }
        });
        return sortedArray;
    }
}
